// src/contexts/AnalyticsContext.js
import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../firebaseConfig';

const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        // Track page views automatically
        trackPageView(location.pathname);
    }, [location]);

    return (
        <AnalyticsContext.Provider value={{ trackPageView }}>
            {children}
        </AnalyticsContext.Provider>
    );
};

export const useAnalytics = () => useContext(AnalyticsContext);